module.exports = __webpack_public_path__ + "img/rank6.4f93b814.png";